document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.youtube-facade').forEach((facade) => {
    facade.addEventListener('click', () => {
      const embedUrl = facade.dataset.embedUrl;
      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', embedUrl);
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:0;';
      facade.innerHTML = '';
      facade.appendChild(iframe);
    });
  });
});
